import { Link, useLocation } from "react-router-dom";
import { ReactComponent as BackArrow } from "../assets/icons/BackArrow.svg";
import { ReactComponent as Arrow } from "../assets/icons/Arrow.svg";
import FaceScan from "../assets/images/FaceScan.png";
import FingerScan from "../assets/images/FingerScan.png";

const SelectOption = () => {
  const { state } = useLocation();
  const scanDuration = state?.scanDuration || 60;
  return (
    <section className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-[#1845a3] to-[#ED1C24] px-5 pt-5 pb-10">
        <div className="flex items-center">
          <Link className="flex-shrink-0 p-1 pr-3" to={-1}>
            <BackArrow className="h-2.5 w-2.5 text-white" />
          </Link>
          <h3 className="text-sm font-semibold text-white tracking-wide">Select Scan Option</h3>
        </div>
        <p className="mt-2 ml-6 text-white/60 text-xxs">Choose your preferred scanning method</p>
      </div>

      <div className="px-5 -mt-6 space-y-4">
        <Link
          className="block rounded-2xl overflow-hidden bg-white shadow-lg border border-gray-100"
          to="/scan-instructions"
          state={{ ...state, scanType: "face" }}
        >
          <div className="p-5 flex items-start space-x-4">
            <div className="shrink-0 w-16 h-16 rounded-xl bg-gradient-to-br from-[#1845a3]/10 to-[#ED1C24]/10 flex items-center justify-center">
              <img className="h-10 w-10" src={FaceScan} alt="face-scan" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-bold text-gray-800">Face Scan</h4>
              <p className="mt-1.5 text-xxs text-gray-400 leading-relaxed">
                {scanDuration}-second contactless vital scan using your smartphone's front camera. It is as simple as taking a selfie.
              </p>
              <div className="inline-flex items-center space-x-1.5 rounded-full mt-3 px-4 py-1.5 bg-gradient-to-r from-[#1845a3] to-[#ED1C24] text-white shadow-sm">
                <span className="text-xxs font-semibold">Start Scan</span>
                <Arrow className="flex-shrink-0 h-2.5 w-2.5" />
              </div>
            </div>
          </div>
        </Link>

        <Link
          className="block rounded-2xl overflow-hidden bg-white shadow-lg border border-gray-100"
          to="/scan-instructions"
          state={{ ...state, scanType: "finger" }}
        >
          <div className="p-5 flex items-start space-x-4">
            <div className="shrink-0 w-16 h-16 rounded-xl bg-gradient-to-br from-[#1845a3]/10 to-[#ED1C24]/10 flex items-center justify-center">
              <img className="h-10 w-10" src={FingerScan} alt="finger-scan" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-bold text-gray-800">Finger Scan</h4>
              <p className="mt-1.5 text-xxs text-gray-400 leading-relaxed">
                Place your finger on the rear camera of your smartphone to scan your vital signs in {scanDuration} seconds.
              </p>
              <div className="inline-flex items-center space-x-1.5 rounded-full mt-3 px-4 py-1.5 bg-gradient-to-r from-[#1845a3] to-[#ED1C24] text-white shadow-sm">
                <span className="text-xxs font-semibold">Start Scan</span>
                <Arrow className="flex-shrink-0 h-2.5 w-2.5" />
              </div>
            </div>
          </div>
        </Link>

        <div className="p-4 rounded-xl bg-gray-100 border border-gray-200">
          <h3 className="text-xxs font-semibold text-gray-500">Disclaimer</h3>
          <p className="mt-1.5 text-xxs text-gray-400 text-justify leading-relaxed">
            For Investigational Use Only. Careplix is not a substitute for the clinical judgment of a healthcare professional.
            Careplix is intended to improve your awareness of general wellness. Careplix does not diagnose, treat, mitigate or
            prevent any disease, symptom, disorder or abnormal physical state. Consult with a health care professional or
            emergency services if you believe you may have a medical issue.
          </p>
          <p className="mt-2 text-gray-400 text-left font-semibold leading-relaxed" style={{ fontSize: "0.55rem" }}>
            Indusindinsurance.com | 022 4890 3009 (Paid) | 74004 22200 (WhatsApp)
          </p>
          <p className="mt-1 text-gray-400 text-justify leading-relaxed" style={{ fontSize: "0.55rem" }}>
            T&C Apply. IRDAI Registration No. 103. IndusInd General Insurance Company Limited (Formerly known as Reliance General Insurance Company Limited). An ISO 9001:2015 Certified Company. Registered & Corporate Office: 6th Floor, Oberoi Commerz, International Business Park, Oberoi Garden City, Off. Western Express Highway, Goregaon (E), Mumbai-400063. Corporate Identity Number: U66603MH2000PLC128300.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SelectOption;
